import { useCallback, useState } from "react";
import { DuplicateJournalUseCase } from "../../domain";
import { JournalRepositoryImpl } from "../../data/repositories/JournalRepositoryImpl";

const journalRepository = new JournalRepositoryImpl();
const duplicateJournalUseCase = new DuplicateJournalUseCase(journalRepository);

export const useDuplicateJournal = () => {
  const [duplicatingJournalId, setDuplicatingJournalId] = useState<number | null>(
    null,
  );
  const [error, setError] = useState<string | null>(null);

  const duplicate = useCallback(async (journalId: number) => {
    setDuplicatingJournalId(journalId);
    setError(null);

    try {
      return await duplicateJournalUseCase.execute(journalId);
    } catch (error: any) {
      const message = error.message || "Failed to duplicate journal";
      setError(message);
      throw error;
    } finally {
      setDuplicatingJournalId(null);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    duplicate,
    duplicatingJournalId,
    loading: duplicatingJournalId !== null,
    error,
    clearError,
  };
};
